import { useState } from "react";
import { CourseSubjectsUIProvider } from "./CourseSubjectsUIContext";
import { ImportFromExcel } from "./ImportFromExcel";
import { CourseSubjectsCard } from "./CourseSubjectsCard";

export function CourseSubjectsPage({
  history, 
  match: {
    params: { page, courseId }
  }
}) {  
  const [showDialog, setShowDialog] = useState(false);
  const closeDialog = () => setShowDialog(false);
    
  const courseSubjectsUIEvents = {
    openImportFromExcelDialog: () => {
      setShowDialog(true);
    },
    openCourseListPage: () => {      
      if (page === "ogretmen") history.push(`/ogretmen/derslerim`);
      else if (page === "ogrenci") history.push(`/ogrenci/derslerim`);
      else history.push(`/sinif-dersleri`);
    },
    openNewCourseSubjectPage: () => {
      if (page === "ogretmen") history.push(`/ogretmen/ders-konulari/ekle/${courseId}`);
      else history.push(`/ders-konulari/ekle/${courseId}`);
    },
    openSubjectOutcomeListPage: (subjectId) => {
      if (page === "ogretmen") history.push(`/ogretmen/konu-kazanimlari/${subjectId}/${courseId}`);
      else if (page === "ogrenci") history.push(`/ogrenci/konu-kazanimlari/${subjectId}/${courseId}`);
      else history.push(`/konu-kazanimlari/${subjectId}/${courseId}`);
    },
    openEditCourseSubjectPage: (id) => {
      if (page === "ogretmen") history.push(`/ogretmen/ders-konulari/duzenle/${id}/${courseId}`);
      else history.push(`/ders-konulari/duzenle/${id}/${courseId}`);
    },
  };
  
  return (
    <CourseSubjectsUIProvider courseId={courseId} courseSubjectsUIEvents={courseSubjectsUIEvents}>
      <ImportFromExcel
        showDialog={showDialog}
        closeDialog={closeDialog}
      />
      <CourseSubjectsCard />
    </CourseSubjectsUIProvider>
 );
}